import React from 'react';
import { Redirect } from 'react-router-dom';

import dashboardRoutes from '../views/dashboard/DashboardRoutes';
import sessionRoutes from '../views/sessions/SessionRoutes';
import userRoutes from '../views/user/UserRoutes';
import contactRoutes from '../views/contacts/ContactRoutes';
import taskRoutes from '../views/task/TaskRoutes';
import leadDetailsRoutes from '../views/leadDetails/LeadDetailsRoutes';
import myLeadsRoutes from '../views/myLeads/MyLeadsRoutes';
import myRestaurantsRoutes from '../views/myRestaurants/MyRestaurantsRoutes';
import myTeamRoutes from '../views/myTeam/MyTeamRoutes';
import cityHeadRoutes from '../views/cityhead/CityHeadRoutes';
import dsrRoutes from '../views/dsr/DsrRoutes';
import delayRoutes from '../views/delays/DelayRoutes';

const redirectRoute = [
	{
		path: '/',
		exact: true,
		component: () => <Redirect to="/dashboard" />,
	},
];

const errorRoute = [
	{
		component: () => <Redirect to="/session/404" />,
	},
];

const routes = [
	...sessionRoutes,
	...dashboardRoutes,
	...userRoutes,
	...redirectRoute,
	...contactRoutes,
	...taskRoutes,
	...leadDetailsRoutes,
	...myLeadsRoutes,
	...myRestaurantsRoutes,
	...myTeamRoutes,
	...cityHeadRoutes,
	...dsrRoutes,
	...delayRoutes,
	...errorRoute,
];

export default routes;
